import React, { FC } from "react";
// redux
import { useAppSelector } from "_redux/hooks";
import {
  isFetchingSelector,
  orderIdSelector,
  selectCheckedTotalsSelector,
} from "_redux/selectors/order";

// mui
import { Box, useMediaQuery, useTheme } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { StyledDivider, StyledProgress } from "components/StyledUI";

// components
import { tss } from "tss-react/mui";
import { formatCurrency } from "tools/stringUtils";
import CartOverview from "./CartOverview";
import MarketplaceCartBaskets from "./MarketplaceCartBaskets";
import MarketplaceShippingAddress from "./MarketplaceShippingAddress";

import {
  ClearCartButton,
  ContinueShoppingButton,
  OrderNowButton,
} from "../CartButtons";

const useStyles = tss.create(({ theme }) => ({
  containerFull: {
    display: "grid",
    width: "100%",
    gridTemplateColumns: "224px 201px 290px auto 50px 187px",
    [theme.breakpoints.down("lg")]: {
      gridTemplateColumns: "auto",
    },
  },
  item1: {
    [theme.breakpoints.down("lg")]: {
      gridRow: "1",
      gridColumn: "1",
    },
    [theme.breakpoints.down("sm")]: {
      gridRow: "1",
      marginRight: "60px",
    },
  },
  item2: {
    [theme.breakpoints.down("lg")]: {
      gridRow: "1",
      gridColumn: "1",
      marginLeft: "228px",
    },
    [theme.breakpoints.down("md")]: {
      gridRow: "3",
      marginLeft: "0",
    },
  },
}));

const MarketplaceCartActions: FC = () => {
  const { classes } = useStyles();

  const isFetching = useAppSelector(isFetchingSelector);
  const orderId = useAppSelector(orderIdSelector);
  const totals = useAppSelector(selectCheckedTotalsSelector);

  const theme = useTheme();
  const breakpointUpMd = useMediaQuery(theme.breakpoints.up("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (!orderId && isFetching) {
    return (
      <Grid container justifyContent="center">
        <StyledProgress />
      </Grid>
    );
  }

  return (
    <>
      {breakpointUpMd && (
        <Box mb={1}>
          <div className={classes.containerFull}>
            <div className={classes.item1}>
              <ContinueShoppingButton />
            </div>
            <div className={classes.item2}>
              <ClearCartButton />
            </div>
          </div>
        </Box>
      )}

      {isMobile && (
        <Box>
          <div className={classes.containerFull}>
            <OrderNowButton fullWidth amount={formatCurrency(totals.total)} />
          </div>
        </Box>
      )}

      <Grid container spacing={2}>
        <Grid xs={12} lg={8}>
          <MarketplaceCartBaskets orderId={orderId} />
          <StyledDivider light pt={0} mt="-1px" />
        </Grid>

        <Grid xs={12} lg={4} mt={1}>
          <CartOverview orderId={orderId} />
          <Box mt={2}>
            <MarketplaceShippingAddress />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default MarketplaceCartActions;
